ScoreTrekBattle.Series = (function() {
    var _this, STATUS;

    STATUS = {
        series: null
    };

    _this = {
        setCurrent: function(series) {
            STATUS.series = series;
        },

        getCurrent: function() {
            return STATUS.series;
        },

        getCurrentName: function(seriesId) {
            var hasSeries;

            hasSeries = STATUS.series && (!seriesId || (STATUS.series.id === seriesId));

            return hasSeries ? STATUS.series.title : __i18n('share/name/series');
        },

        getShareHash: function(seriesId) {
            return `/series/${seriesId}`;
        }
    };

    return _this;
})();
